import SvgIcon from '@material-ui/core/SvgIcon'

const WarningIcon = (props) => (
  <SvgIcon {...props} data-testid="WarningIcon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.18594 9.99998C3.18594 6.23669 6.23669 3.18594 9.99998 3.18594C13.7633 3.18594 16.814 6.23669 16.814 9.99998C16.814 13.7633 13.7633 16.814 9.99998 16.814C6.23669 16.814 3.18594 13.7633 3.18594 9.99998ZM1.66695 9.99998C1.66695 5.39777 5.39778 1.66695 9.99998 1.66695C14.6022 1.66695 18.333 5.39778 18.333 9.99998C18.333 14.6022 14.6022 18.333 9.99998 18.333C5.39777 18.333 1.66695 14.6022 1.66695 9.99998ZM10.898 14.4521L9.11241 14.4521L9.11241 12.8096L10.898 12.8096L10.898 14.4521ZM10.8931 11.6666L9.10984 11.6666L9.10984 5.4168L10.8931 5.4168L10.8931 11.6666Z" fill="#F0F1F5" />
    </g>
  </SvgIcon>
)

export default WarningIcon
